import * as qsLibrary from 'qs';
import { axiosTemplate } from '../../axiosTemplate';
export const movFullReports = {
    endpoints: {
        test: `https://e9qv8oveic.execute-api.us-east-1.amazonaws.com/test`,
        acceptance: `https://zs13wlgxfe.execute-api.us-east-1.amazonaws.com/acceptance`,
        prod: `https://i4zk5nofdk.execute-api.us-east-1.amazonaws.com/prod`,
    },
    http: {
        create: ({ metjwt, stage, data, cancelToken, headers }) => {
            return axiosTemplate(metjwt, cancelToken, headers).post(`${movFullReports.endpoints[stage]}/reports`, data);
        },
        remove: ({ reportId, metjwt, stage, cancelToken, headers }) => {
            return axiosTemplate(metjwt, cancelToken, headers).delete(`${movFullReports.endpoints[stage]}/reports/${reportId}`);
        },
        get: ({ reportId, stage, metjwt, cancelToken, headers }) => {
            return axiosTemplate(metjwt, cancelToken, headers).get(`${movFullReports.endpoints[stage]}/reports/${reportId}`);
        },
        update: ({ data, metjwt, reportId, stage, cancelToken, headers }) => {
            return axiosTemplate(metjwt, cancelToken, headers).put(`${movFullReports.endpoints[stage]}/reports/${reportId}`, data);
        },
        getAll: ({ stage, metjwt, qs, cancelToken, headers }) => {
            const queryString = qs ? `?${qs}` : '';
            return axiosTemplate(metjwt, cancelToken, headers).get(`${movFullReports.endpoints[stage]}/reports${queryString}`);
        },
        getReportList: ({ stage, metjwt, qs, cancelToken, headers }) => {
            const queryString = qs ? `?${qs}` : '';
            return axiosTemplate(metjwt, cancelToken, headers).get(`${movFullReports.endpoints[stage]}/listreports${queryString}`);
        },
        getAllByMovSiteId: ({ stage, metjwt, movSiteId, cancelToken, headers }) => {
            const qs = {
                movSiteId,
            };
            const queryString = qsLibrary.stringify(qs);
            return axiosTemplate(metjwt, cancelToken, headers).get(`${movFullReports.endpoints[stage]}/reports?${queryString}`);
        },
        getTemplates: ({ metjwt, stage, cancelToken, headers }) => {
            return axiosTemplate(metjwt, cancelToken, headers).get(`${movFullReports.endpoints[stage]}/templates`);
        },
        updateMarkdownContent: ({ stage, metjwt, reportId, widgetblockId, content, headers }) => {
            return axiosTemplate(metjwt, headers).put(`${movFullReports.endpoints[stage]}/updateMarkdownContent`, {
                reportId,
                widgetblockId,
                content,
            });
        },
        getHistoricalReport: ({ metjwt, reportId, historicalReportId, stage, cancelToken, headers }) => {
            return axiosTemplate(metjwt, cancelToken, headers).get(`${movFullReports.endpoints[stage]}/reports/${reportId}/history/${historicalReportId}`);
        },
        getHistoricalReportsMeta: ({ metjwt, reportId, stage, cancelToken, headers }) => {
            return axiosTemplate(metjwt, cancelToken, headers).get(`${movFullReports.endpoints[stage]}/reports/${reportId}/history`);
        },
        updateReportRelations: ({ metjwt, id, relations, stage, cancelToken, headers }) => {
            const data = relations;
            return axiosTemplate(metjwt, cancelToken, headers).put(`${movFullReports.endpoints[stage]}/reports/${id}/relations`, data);
        },
        getSpecificReports: ({ qs, metjwt, stage, abortSignal, headers }) => {
            const queryString = qs ? `?${qs}` : '';
            return axiosTemplate(metjwt, undefined, headers, abortSignal).get(`${movFullReports.endpoints[stage]}/reports/reports${queryString}`);
        },
        getReportIdsByQuery: ({ qs, metjwt, stage, abortSignal, headers }) => {
            const queryString = qs ? `?${qs}` : '';
            return axiosTemplate(metjwt, undefined, headers, abortSignal).get(`${movFullReports.endpoints[stage]}/reports/query${queryString}`);
        },
        getSearchableReports: ({ metjwt, stage, abortSignal, headers }) => {
            return axiosTemplate(metjwt, undefined, headers, abortSignal).get(`${movFullReports.endpoints[stage]}/reports/search`);
        },
    },
};
